//react
import React, { useState, useCallback, useEffect, useContext } from "react";
import { navigate } from "hookrouter";
import { fullApiUrl } from "../utils/NetworkSettings";

import { sha256 } from "js-sha256";

//Context API for User Info
import { InfoContext } from "./../context/InfoContext";

//Images
import logo from "./../assets/gmr_logo_light.png";

//httpClient
import AuthenticationClient from "./../httpClient/Authentication";

const Intro = ({error = "", loadingProp = false}) => {
  //current user Info
  const { info, setInfo } = useContext(InfoContext);

  const [loading, setLoading] = useState(false);
  const [loadingOkta, setLoadingOkta] = useState(loadingProp);

  const [errorMessage, setErrorMessage] = useState(error);
  const [successMessage, setSuccessMessage] = useState("");
  const [loginScreen, setLoginScreen] = useState(true);
  const [userRecord, setUserRecord] = useState({
    employeeNumber: "",
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  //on component mount
  useEffect(() => {
    if (info !== null) {
      navigate("/copa/dashboard");
    }
  }, []);

  useEffect(() => {
    setErrorMessage(error)
    setLoadingOkta(loadingProp)
  }, [error, loadingProp])

  const oktaLogin = () => {
    let samlCallbackUrl = window.location.origin + "/copa/samlCallback";
    window.location.href =
      fullApiUrl + "saml/Login?returnUrl=" + samlCallbackUrl;
  };


  const updateUserRecord = useCallback((e) => {
    const { name, value } = e.target;
    setUserRecord((userRecord) => {
      return {
        ...userRecord,
        [name]: value,
      };
    });
  }, []);

  const validateInput = (e) => {
    e.preventDefault()
    //validate Input Fields
    let emailAddressPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!emailAddressPattern.test(userRecord.email)) {
      setErrorMessage("Please enter a valid Email Address");
      return;
    } else if (
      !loginScreen &&
      userRecord.password !== userRecord.confirmPassword
    ) {
      setErrorMessage("Password fields do not match");
      return;
    } else {
      setErrorMessage("");
      loginScreen ? loginUser() : createAccount();
    }
  };

  const loginUser = () => {
    setLoading(true);

    //Add Password Encryption
    let encryptedPassword = sha256(userRecord.password);
    AuthenticationClient.loginUser(userRecord.email, encryptedPassword)
      .then((data) => {
        setLoading(false);
        setInfo(data.userRecord);
        navigate("/dashboard");
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(err.response.data.Message);
      });
  };

  const createAccount = () => {
    setLoading(true);
    let encryptedPassword = sha256(userRecord.password);

    AuthenticationClient.registerUser({
      "employeeNumber": userRecord.employeeNumber,
      "fullName": userRecord.fullName,
      "email": userRecord.email,
      "password": encryptedPassword
    })
    .then(data => {
      setLoading(false);
      setLoginScreen(true);
      setSuccessMessage(data.Message);
    })
    .catch(err => {
      setLoading(false);
      setErrorMessage(err.response.data.Message);
    });

  }

  return (
    <section className="main-app">
      <div className="intro-holder">
        <div className="container">
          <div className="">
            <div className="">
              <div className="is-link  is-white has-text-centered">
                <img src={logo} className="App-logo" alt="logo" />
                <br />
                <br />
                <h3 className="subtitle has-text-white">
                  Clinical Outcomes and Performance Analysis (CO/PA)
                </h3>
              </div>
              <br />

              {errorMessage.length > 0 && (
                <div className="columns is-centered">
                  <div className="column">
                    <article className="message is-danger">
                      <div className="message-header">
                        <p>Error</p>
                        <button
                          className="delete"
                          aria-label="delete"
                          onClick={() => setErrorMessage("")}
                        />
                      </div>
                      <div className="message-body">
                        <strong>{errorMessage}</strong>
                      </div>
                    </article>
                  </div>
                </div>
              )}

              {successMessage.length > 0 && (
                <div className="columns is-centered">
                  <div className="column">
                    <article className="message is-primary">
                      <div className="message-header">
                        <p>Success</p>
                        <button
                          className="delete"
                          aria-label="delete"
                          onClick={() => setSuccessMessage("")}
                        />
                      </div>
                      <div className="message-body">
                        <strong>{successMessage}</strong>
                      </div>
                    </article>
                  </div>
                </div>
              )}

              {loginScreen ? (
                <form onSubmit={validateInput} className="box page-main">
                  <div className="field">
                    <label htmlFor="" className="label">
                      Email
                    </label>
                    <div className="control">
                      <input
                        type="input"
                        name="email"
                        value={userRecord.email}
                        placeholder="e.g. alexsmith@gmail.com"
                        className="input"
                        onChange={updateUserRecord}
                        required
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label htmlFor="" className="label">
                      Password
                    </label>
                    <div className="control">
                      <input
                        type="password"
                        name="password"
                        value={userRecord.password}
                        placeholder="At least 6 characters long"
                        className="input"
                        onChange={updateUserRecord}
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <button
                      type="submit"
                      className={`button is-success is-fullwidth ${
                        loading ? "is-loading" : ""
                      }`}
                      disabled={
                        errorMessage.length > 0 ||
                        userRecord.email.length === 0 ||
                        userRecord.password.length < 6
                      }
                    >
                      Login
                    </button>
                    <br />
                    <h4 className="has-text-centered">
                      <strong>
                        <a
                          className="activeLink"
                          onClick={() => setLoginScreen(false)}
                        >
                          Create Account
                        </a>
                      </strong>
                    </h4>
                  </div>
                </form>
              ) : (
                <div className="box page-main">
                  <div className="field">
                    <label htmlFor="" className="label">
                      Employee Number
                    </label>
                    <div className="control">
                      <input
                        type="input"
                        name="employeeNumber"
                        value={userRecord.employeeNumber}
                        placeholder="e.g. 1986212"
                        className="input"
                        onChange={updateUserRecord}
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="" className="label">
                      Full Name
                    </label>
                    <div className="control">
                      <input
                        type="input"
                        name="fullName"
                        value={userRecord.fullName}
                        placeholder="e.g. Alex Smith"
                        className="input"
                        onChange={updateUserRecord}
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="" className="label">
                      Email
                    </label>
                    <div className="control">
                      <input
                        type="input"
                        name="email"
                        value={userRecord.email}
                        placeholder="e.g. alexsmith@gmail.com"
                        className="input"
                        onChange={updateUserRecord}
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="" className="label">
                      Password
                    </label>
                    <div className="control">
                      <input
                        type="password"
                        name="password"
                        value={userRecord.password}
                        placeholder="atleast 6 characters long"
                        className="input"
                        onChange={updateUserRecord}
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label htmlFor="" className="label">
                      Confirm Password
                    </label>
                    <div className="control">
                      <input
                        type="password"
                        name="confirmPassword"
                        value={userRecord.confirmPassword}
                        placeholder="atleast 6 characters long"
                        className="input"
                        onChange={updateUserRecord}
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <button
                      className={`button is-success is-fullwidth ${
                        loading ? "is-loading" : ""
                      }`}
                      disabled={
                        errorMessage.length > 0 ||
                        userRecord.employeeNumber.length === 0 ||
                        userRecord.fullName.length === 0 ||
                        userRecord.email.length === 0 ||
                        userRecord.password.length < 6 ||
                        userRecord.confirmPassword.length < 6
                      }
                      onClick={validateInput}
                    >
                      Create Account
                    </button>
                    <br />
                    <h4 className="has-text-centered">
                      <strong>
                        Already got an account?{" "}
                        <a
                          className="activeLink"
                          onClick={() => setLoginScreen(true)}
                        >
                          Login Here
                        </a>
                      </strong>
                    </h4>
                  </div>
                </div>
              )}

              <h2 className="decorated"><span>Or</span></h2>

              <div className="field mt-4">
                <button
                  className={`button is-info is-fullwidth ${
                    loadingOkta ? "is-loading" : ""
                  }`}
                  onClick={oktaLogin}
                >
                  Login with Okta
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
